(function () {
  function formatMoney(cents, moneyFormat) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, moneyFormat);
    }

    var currency = window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active
      : 'USD';

    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  function initializeTotalCost(root) {
    if (!root || root.dataset.totalCostReady === 'true') return;

    var quantityInput = root.querySelector('.sliderqty');
    var totalCostOutput = root.querySelector('[data-total-cost-output]');

    if (!quantityInput || !totalCostOutput) return;

    root.dataset.totalCostReady = 'true';

    function updateTotalCost() {
      var unitPrice = Number(root.dataset.unitPrice) || 0;
      var quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
      totalCostOutput.value = formatMoney(unitPrice * quantity, root.dataset.moneyFormat);
    }

    quantityInput.addEventListener('input', updateTotalCost);
    quantityInput.addEventListener('change', updateTotalCost);

    root.addEventListener('click', function (event) {
      if (!event.target.closest('.js-qty__adjust')) return;
      window.requestAnimationFrame(updateTotalCost);
    });

    document.addEventListener('variant:change', function (event) {
      if (!event.detail || !event.detail.variant) return;
      root.dataset.unitPrice = event.detail.variant.price;
      updateTotalCost();
    });

    updateTotalCost();
  }

  function enhanceQuantityWithTotalCost(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    context.querySelectorAll('.product-section .product-single__meta').forEach(function (productMeta) {
      productMeta.classList.add('product-single__meta--pdp');
    });

    context.querySelectorAll('.product-section .product-single__meta .product__quantity').forEach(function (quantity) {
      if (quantity.classList.contains('ttlholder')) return;
      if (quantity.closest('[data-pdp-total-cost]')) return;
      if (quantity.closest('qty-table-form, .qty-table, .qbreaks, .product__quantity-break-table, [data-store-availability-holder]')) return;

      var existingQuantityRow = quantity.closest('.flxwrap__qty');
      if (existingQuantityRow && existingQuantityRow.querySelector('.ttlholder')) return;

      var quantityInput = quantity.querySelector('.sliderqty');
      var productSection = quantity.closest('.product-section');

      if (!quantityInput || !productSection) return;

      var unitPrice = 0;
      var variantJson = productSection.querySelector('[data-variant-json]');
      var variantIdInput = productSection.querySelector('[name="id"]');

      if (variantJson) {
        try {
          var variants = JSON.parse(variantJson.value || variantJson.textContent);
          var selectedVariantId = variantIdInput ? String(variantIdInput.value) : '';
          var selectedVariant = variants.find(function (variant) {
            return String(variant.id) === selectedVariantId;
          }) || variants.find(function (variant) {
            return variant.available;
          }) || variants[0];

          unitPrice = selectedVariant ? Number(selectedVariant.price) : 0;
        } catch (error) {
          unitPrice = 0;
        }
      }

      if (!unitPrice) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'flxwrap__qty pdp-shared-quantity-total';
      wrapper.setAttribute('data-pdp-total-cost', '');
      wrapper.dataset.unitPrice = unitPrice;
      wrapper.dataset.moneyFormat =
        window.theme && window.theme.settings
          ? window.theme.settings.moneyFormat
          : '${{amount}}';

      quantity.parentNode.insertBefore(wrapper, quantity);
      wrapper.appendChild(quantity);

      var totalCost = document.createElement('div');
      totalCost.className = 'product__quantity ttlholder';
      totalCost.innerHTML =
        '<label class="d-flex qty-label" for="TotalCost-' + quantityInput.id + '">Total Cost</label>' +
        '<input type="text" id="TotalCost-' + quantityInput.id + '" data-total-cost-output readonly aria-label="Total Cost">';
      wrapper.appendChild(totalCost);
    });
  }

  function normalizePdpContent(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var policyMarkup = [
      '<p class="bit-title">1-YEAR WARRANTY</p><p class="bit-subtext"><a href="/pages/warranty" title="Warranty">Warranty Policy</a></p>',
      '<p class="bit-title">FREE GIFT ON ORDERS</p><p class="bit-subtext">over $99.99</p>',
      '<p class="bit-title">14-DAY <span class="pdp-mobile-line-break"></span>RETURNS</p><p class="bit-subtext"><a href="/pages/privacy-policy" title="Privacy Policy">View Policy</a></p>'
    ];

    context.querySelectorAll('.product-section .product-single__meta .product-block--icon_text .block-icon_text--row').forEach(function (row) {
      var columns = row.querySelectorAll('.block-icon_text--col');
      if (columns.length < 3) return;

      policyMarkup.forEach(function (markup, index) {
        var content = columns[index].querySelector('.block-icon_text--content');
        if (content) content.innerHTML = markup;
      });
    });

    context.querySelectorAll('.product-section .login-to-earn-points strong').forEach(function (strong) {
      var pointsText = strong.textContent.trim();
      if (!/^\d[\d,]* Points$/i.test(pointsText)) return;
      strong.textContent = '(' + pointsText + ')';
    });

    context.querySelectorAll('.product-section .secnttl').forEach(function (heading) {
      var normalizedHeading = heading.textContent.replace(/^\s*[12]\.\s*/, '');
      if (normalizedHeading !== heading.textContent) heading.textContent = normalizedHeading;
    });

    context.querySelectorAll('.product-section .secndsc').forEach(function (description) {
      if (description.textContent.trim() !== 'Enter the quantity you like or click the table.') return;
      description.hidden = true;
    });

    context.querySelectorAll('.product-section').forEach(function (productSection) {
      var hasBulkPricingTable = productSection.querySelector(
        'qty-table table, table.gridiscstbl, bulk-pricing-table table, bulk-pricing-form table'
      );

      if (hasBulkPricingTable) return;

      productSection.querySelectorAll('.secnttl').forEach(function (heading) {
        if (heading.textContent.trim() === 'Click to Select/Enter Quantity') heading.hidden = true;
      });

      productSection.querySelectorAll('.bulksvmsg').forEach(function (message) {
        if (message.textContent.trim().toLowerCase() === 'buy more, save more') message.hidden = true;
      });
    });
  }

  function initializeAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    enhanceQuantityWithTotalCost(context);
    normalizePdpContent(context);
    context.querySelectorAll('[data-pdp-total-cost]').forEach(initializeTotalCost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
